import { render } from "./VentaMetodoPago.vue?vue&type=template&id=4ac708d3&scoped=true"
import script from "./VentaMetodoPago.vue?vue&type=script&lang=js"
export * from "./VentaMetodoPago.vue?vue&type=script&lang=js"

import "./VentaMetodoPago.vue?vue&type=style&index=0&id=4ac708d3&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac708d3"]])

export default __exports__